//import HttpClient from "@/common/boot/HttpClient"
import HttpClientModos from '@/common/boot/HttpClientModos'
import HttpClient from '@/common/boot/HttpClient'
import { criarCookie, cookieEstaValido, removerCookie } from '@/common/boot/CookiesHandler';
// import router from "@/router";
// import moment from "moment/moment";

const nomeCookie = 'modos-token';

const logarUsuario = async ({ commit }, payload) => {

    commit('LOGANDO', true);

    const resp = await HttpClientModos.post('/login-rpa', payload).then(response => {

    //const resp = await HttpClient.post('/gestao-producao/modos/loginModos', payload).then(response => {       
        commit('SALVAR_USUARIO_STATE', response.data);

        criarCookie({
            nome: nomeCookie,
            valor: response.data.token,
            expiraEm: `${response.data.token_expires_in}min`
        });
        
        return response;
    })
    .catch(error => {
        return error.response
    })
    .finally(() => {
        commit('LOGANDO', false);
    });

    return resp
}

const usuarioEstaLogado = ({ dispatch }) => {
    if (cookieEstaValido(nomeCookie)) {
        return true
    }
    dispatch('deslogarUsuario');
    return false
}

const deslogarUsuario = async ({ commit }, payload) => {
    const resp = await HttpClientModos.post('/logout', payload).then(response => {
        removerCookie(nomeCookie)
        return response
    }).finally(() => {
        commit('LOGANDO', false);
    });

    return resp
}

const listarAreasResponsaveis = async ({ commit }) => {
    commit('LOADING', true);
  
    return await HttpClientModos.get('/ordem-servico/ctrl-areas-responsaveis').then(response => {
      commit('LISTAR_DADOS_AREA_RESPONSAVEL', response.data.data)
      return response;
    })
    .finally( () => {
      commit('LOADING', false);
    })
}

const listarTiposOS = async ({ commit }) => {
    commit('LOADING', true);  
    HttpClientModos.get('/ordem-servico/ctrl-tipos-ordens-servicos').then(response => {
      commit('LISTAR_DADOS_TIPO_OS', response.data.data)
      return response;
    })
    .finally( () => {
      commit('LOADING', false);
    })  
    return true
}

const listarGruposAtividades = async ({ commit }) => {
    commit('LOADING', true);
  
    HttpClientModos.get('/ordem-servico/ctrl-grupos-atividades').then(response => {
      commit('LISTAR_DADOS_GRUPO_ATIVIDADE', response.data.data)
      return response;
    })
    .finally( () => {
      commit('LOADING', false);
    })
  
    return true
}
  

const listarAtividades = async ({ commit }) => {
    commit('LOADING', true);
  
    HttpClientModos.get('/ordem-servico/ctrl-atividades').then(response => {
      commit('LISTAR_DADOS_ATIVIDADE', response.data.data)
      return response;
    })
    .finally( () => {
      commit('LOADING', false);
    })
  
    return true
}

const salvarOrdemServico = async({ commit }, payload) => {
    commit('LOADING', true);
  
    const headers = {
      "Content-Type": "multipart/form-data",
    };
  
    return await HttpClientModos.post('/ordem-servico/registrar-os', payload, { headers }).then(response => {    
      return response;
    })
    .finally(() => {
      commit('LOADING', false);
    });
}

const editarOrdemServico = async({ commit }, payload) => {
  commit('LOADING', true);

  return await HttpClientModos.post('/ordem-servico/editar-os', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const listarJanelas = async ({ commit }, payload) => {

    commit('LOADING', true);
  
    return await HttpClientModos.get(`/ordem-servico/${payload.ctrl_atividade_id}/${payload.data_janela}/listar-janelas`).then(response => {
      commit('LISTAR_JANELAS', response.data.data)
      return response;
    })
    .finally( () => {
      commit('LOADING', false);
    })
}

const listarJanelasPorTarefa = async ({ commit }, payload) => {

  commit('LOADING', true);

  return await HttpClientModos.get(`/ordem-servico/${payload.ctrl_tarefa_id}/${payload.data_janela}/listar-janelas-por-tarefa`).then(response => {    
    commit('LISTAR_JANELAS', response.data)
    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  })
}

const registrarOsTarefa = async({ commit }, payload) => {
  commit('LOADING', true);

  return await HttpClient.post('/gestao-producao/ordem-servico-tarefa/registrar-os-tarefa', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const listarOsModos = async({ commit }, payload) => {
  commit('LOADING', true);

  return await HttpClientModos.post('/ordem-servico/listar-ordens-de-servicos', payload).then(response => {    
    commit('SALVAR_ORDENS_SERVICOS', response.data)
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const getFormularioEditar = async ({ commit }, payload) => {
  commit('LOADING', true);

  return await HttpClientModos.get(`/ordem-servico/get-dados-editar-os/${payload}`).then(response => {    
    commit('LISTAR_FORMULARIOS', response.data.data)
    return response.data.data;
  })
  .finally( () => {
    commit('LOADING', false);
  })
}

const reagendarOS = async ({ commit }, payload) => {
  commit('LOADING', true);
  return await HttpClientModos.post(`/ordem-servico/tarefas/reagendar-os/${payload.pcoOrdemServicoId}`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  });
}

const cancelarOS = async ({ commit }, payload) => {
  commit('LOADING', true);
  return await HttpClientModos.post(`/ordem-servico/tarefas/cancelar-os/${payload.pcoOrdemServicoId}`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  });
}

const cancelarTarefaModos = async ({ commit }, payload) => {
  commit('LOADING', true);
  return await HttpClientModos.post(`/ordem-servico/cancelar-tarefa`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  });
}

const getCnl = async ({ commit }, payload) => {
  commit('LOADING', true);
  return await HttpClientModos.get(`/ordem-servico/cnl/${payload}`).then(response => {    
    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  })
}

const listarTarefasDisponiveisAposIncluirOs = async ({ commit }, pcoOrdemServicoId) => {
  commit('LOADING', true);
  return await HttpClientModos.get(`/ordem-servico/listar-tarefas-disponiveis-apos-inclusao-os/${pcoOrdemServicoId}`).then(response => {    

    commit('LISTAR_TAREFAS_APOS_INCLUIR_OS', response.data.data)

    return response;
  })
  .finally( () => {
    commit('LOADING', false);
  })
}

const salvarNovaTarefa = async({ commit }, payload) => {
  commit('LOADING', true);
  
  return await HttpClientModos.post('/ordem-servico/cadastrar-nova-tarefa-apos-inclusao-os', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const getUserCec = async({ commit }, payload) => {
  commit('LOADING', true);
  
  return await HttpClient.post('/gestao-producao/modos/get-user-cec', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const dadosAberturaModos = async({ commit }, payload) => {
  commit('LOADING', true);
  
  return await HttpClient.post('/gestao-producao/modos/dados-abertura-modos', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

const adicionarDesignacao = async({ commit }, payload) => {
  commit('LOADING', true);
  
  return await HttpClientModos.post('/ordem-servico/adicionar-designacao', payload).then(response => {    
    return response;
  })
  .finally(() => {
    commit('LOADING', false);
  });
}

export {
    logarUsuario,
    usuarioEstaLogado,
    deslogarUsuario,
    listarAreasResponsaveis,    
    listarTiposOS,
    listarGruposAtividades,
    listarAtividades,
    salvarOrdemServico,
    editarOrdemServico,
    listarJanelas,
    listarJanelasPorTarefa,
    registrarOsTarefa,
    listarOsModos,
    getFormularioEditar,
    reagendarOS,
    cancelarOS,
    cancelarTarefaModos,
    getCnl,
    listarTarefasDisponiveisAposIncluirOs,
    salvarNovaTarefa,
    getUserCec,
    dadosAberturaModos,
    adicionarDesignacao
}